import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { computed, useAttrs, provide } from "vue";

export type ProvideFormInline = boolean;


const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FormInline',
  setup(__props) {

const attrs = useAttrs();
const computedClass = computed(() =>
  twMerge([
    "block sm:flex items-center",
    typeof attrs.class === "string" && attrs.class,
  ])
);

provide<ProvideFormInline>("formInline", true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: _unref(computedClass) }, _unref(_).omit(_unref(attrs), 'class')), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}
}

})